export default "__VITE_ASSET__cC_Ts8vr__"